import { colorsPalettes, mixins } from "@similarweb/styles";
import styled from "styled-components";

export const ModalBody = styled.div`
    text-align: center;
    padding: 50px 20px;
`;

export const SuccessTitle = styled.div`
    color: ${colorsPalettes.carbon["500"]};
    font-weight: 500;
    font-size: 26px;
`;

export const SuccessSubtitle = styled.div`
    ${mixins.setFontVariant("subTitle3Alt", colorsPalettes.carbon[400])};
    margin-top: 16px;
`;

export const SuccessImageWrapper = styled.div`
    margin-bottom: 56px;
`;
